import { useEffect, useState } from 'react'
import { Link } from 'react-router-dom'
import { api } from '../../api/client'

type Summary = {
  analytics?: {
    indicators: Array<{
      id: string
      title: string
      state_label: string
      value: number | null
      unit: string
      n: number
      note: string
    }>
  }
}

export function ReportPreview() {
  const [data, setData] = useState<Summary | null>(null)
  const [error, setError] = useState('')
  const [retry, setRetry] = useState(0)
  useEffect(() => {
    let active = true
    setError('')
    api
      .get<Summary>('/know/me/reports')
      .then((r) => {
        if (active) setData(r)
      })
      .catch((e) => {
        if (active)
          setError(
            e instanceof Error ? e.message : 'No pudimos cargar el resumen.',
          )
      })
    return () => {
      active = false
    }
  }, [retry])
  const indicators =
    data?.analytics?.indicators.filter((i) =>
      ['control', 'recovery', 'precision'].includes(i.id),
    ) ?? []
  return (
    <section className="card space-y-md" aria-label="Tu resumen de práctica">
      <div className="flex flex-wrap items-center justify-between gap-md">
        <h2 className="text-lg font-semibold">Tu práctica</h2>
        <Link className="btn-primary" to="/data/reports">
          Ver mi informe
        </Link>
      </div>
      {!data && !error && <p role="status">Preparando tu resumen…</p>}
      {error && (
        <p role="alert">
          {error}{' '}
          <button className="btn-ghost" onClick={() => setRetry((x) => x + 1)}>
            Reintentar
          </button>
        </p>
      )}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-md">
        {indicators.map((i) => (
          <div className="min-w-0" key={i.id}>
            <h3 className="font-medium text-sm">{i.title}</h3>
            <p className="text-xl font-semibold">
              {i.value == null
                ? 'Sin dato'
                : `${i.value.toLocaleString('es-AR', { maximumFractionDigits: 2 })} ${i.unit}`}
            </p>
            <p className="text-sm text-text-muted">
              {i.state_label} · n = {i.n}
            </p>
            <p className="text-xs text-text-muted">{i.note}</p>
          </div>
        ))}
      </div>
      {data && !indicators.length && (
        <p className="text-sm text-text-muted">
          Todavía no hay mediciones suficientes para construir tu resumen. El
          informe muestra qué datos faltan.
        </p>
      )}
    </section>
  )
}
